<template>
  <section id="about" class="bg-black text-white text-center">
    <div class="lg:px-48 md:px-12 px-6 py-20">
      <div class="flex justify-center">
        <h2 class="secondaryTitle bg-underline2 bg-100% inline-block">{{ t('about.title') }}</h2>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-0 mt-4">
        <div
          v-for="(item, i) in items"
          :key="item.title"
          class="flex flex-col items-center text-center px-8 py-12"
          :class="i < items.length - 1 ? 'md:border-r border-white/10' : ''"
        >
          <div class="border border-white/30 rounded-full h-20 w-20 flex justify-center items-center mb-8">
            <svg v-html="item.icon" class="w-9 h-9 text-white/80" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" />
          </div>
          <h3 class="font-pt-serif text-2xl font-bold mb-4 text-white">{{ item.title }}</h3>
          <p class="font-montserrat text-base opacity-60 leading-relaxed">{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const { t } = useI18n()

const items = computed(() => [
  {
    icon: '<path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />',
    title: t('about.lessons'),
    desc: t('about.lessonsDesc'),
  },
  {
    icon: '<path stroke-linecap="round" stroke-linejoin="round" d="M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />',
    title: t('about.free'),
    desc: t('about.freeDesc'),
  },
  {
    icon: '<path stroke-linecap="round" stroke-linejoin="round" d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />',
    title: t('about.messenger'),
    desc: t('about.messengerDesc'),
  },
])
</script>
